import { createAction, props } from '@ngrx/store';
import { IAddEFTRequest } from '../models/add-eft.model';

export const loadAddEfts = createAction('[AddEft] Load AddEfts', props<{ businessId: string; addEft: IAddEFTRequest }>());

export const loadAddEftsSuccess = createAction('[AddEft] Load AddEfts Success', props<{ response: string }>());

export const loadAddEftsFailure = createAction('[AddEft] Load AddEfts Failure', props<{ error: Error | any }>());
